import { render, staticRenderFns } from "./WaterShutOffDevice.vue?vue&type=template&id=022f9ac8&"
import script from "./WaterShutOffDevice.vue?vue&type=script&lang=js&"
export * from "./WaterShutOffDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports